import React, { useContext, useState } from 'react';
import ButtonGroup from '@visa/vds/button-group';
import ButtonText from '@visa/vds/button-text';
import Typography from '@visa/vds/typography'
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import Select from '@visa/vds/select';
import { PageHelper } from '../../../_helpers/PageHelper';
import { adminService } from '../../../services/admin.service';
import { userService } from '../../../services/user.service';
import Announcement from './Announcement';
import { GlobalAlertContext } from '../../../context/GlobalAlertContext';
import ManageAnnouncementDialog from './ManageAnnouncementDialog';
import NewAnnouncementDialog from './NewAnnouncementDialog';
import ViewAnnouncementDialog from './ViewAnnouncementDialog';

function ManageAnnouncement() {
    const PAGE_SIZE = 10
    var state = "active"
    if (document.getElementById("selectState")) {
        state = document.getElementById("selectState").value;
    }
    const [superAdmin, setSuperAdmin] = useState(false);
    const [toolsAndLibAdmin, setToolsAndLibAdmin] = useState(false);
    const [storeAdmin, setStoreAdmin] = useState(false);
    const [announcementState, setAnnouncementState] = useState("");
    const [announcementFetched, setAnnouncementFetched] = useState(false);
    const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
    const [announcementsData, setAnnouncementsData] = useState(null);
    const [announcementTotalPages, setAnnouncementTotalPages] = useState(0);
    const [newAnnouncement, setNewAnnouncement] = useState(false);
    const [newAnnouncementDto, setNewAnnouncementDto] = useState({
        startDate: null,
        endDate: null,
        announcementName: null,
        announcementDetails: null,
        us: null,
        canada: null,
        eu: null,
        ap: null,
        lac: null,
        cemea: null,
        publishState: null
    })

    const checkAdmin = async () => {
        const userClaims = await userService.GetClaims();
        //setSuperAdmin(true);
        if (userClaims.user.isSuperAdmin == true) {
            setSuperAdmin(true);
        } else {
            setSuperAdmin(false);
        }
        if (userClaims.user.isToolsAndLibAdmin == true) {
            setToolsAndLibAdmin(true);
        } else {
            setToolsAndLibAdmin(false);
        }
        if (userClaims.user.isStoreAdmin == true) {
            setStoreAdmin(true);
        } else {
            setStoreAdmin(false);
        }
    }

    const changeAnnouncementState = (event) => {
        const newState = event.target.value;
        setAnnouncementState(newState);
        state = newState;
        handleAnnouncementsPageChange(1);
        setAnnouncementState(state);
    }
    
    const handleAnnouncementsPageChange = async (page) => {
        setAnnouncementFetched(false);
        let skipCount = PageHelper.GetSkipCount(PAGE_SIZE, page)
        if (document.getElementById("selectState")) {
            state = document.getElementById("selectState").value;
        }
        const AnnouncementFrom = await adminService.GetAnnouncements(state, skipCount)
        console.log('Fetched Announcements:', AnnouncementFrom);
        setAnnouncementsData(AnnouncementFrom);
        setAnnouncementTotalPages(AnnouncementFrom.totalCount != null ? PageHelper.GetTotalCountToPages(PAGE_SIZE, AnnouncementFrom.totalCount):0);
        setAnnouncementFetched(true);
    }

    const tablesRefresh = async () => {
        handleAnnouncementsPageChange(1);
    }

    React.useEffect(() => {
        handleAnnouncementsPageChange(1);
        checkAdmin();
    }, []);

    return (
        <GlobalAlertContext.Consumer>
            {
                alertObj => (
                    <>
                        <ManageAnnouncementDialog alertObj={alertObj} tablesRefresh={tablesRefresh} selectedAnnouncementDto={selectedAnnouncement} openAnnouncementDialog={selectedAnnouncement != null && superAdmin == true} setSelectedAnnouncementDto={setSelectedAnnouncement} />
                        <NewAnnouncementDialog alertObj={alertObj}  tablesRefresh={tablesRefresh} newAnnouncementDto={newAnnouncementDto} openNewAnnouncementDialog={newAnnouncement == true && superAdmin == true} setNewAnnouncementDto={setNewAnnouncementDto} setNewAnnouncement={setNewAnnouncement} />
                        <ViewAnnouncementDialog alertObj={alertObj} tablesRefresh={tablesRefresh} announcement={selectedAnnouncement} openAnnouncementDialog={selectedAnnouncement != null && superAdmin == false} setSelectedAnnouncement={setSelectedAnnouncement} toolsAndLibAdmin={toolsAndLibAdmin} storeAdmin={storeAdmin}/>
                        <Grid>
                            <Row>
                                <Col>
                                    <Typography tag="h1">Manage Announcement</Typography>
                                    {(superAdmin == true) && 
                                        <ButtonGroup direction="right">
                                            <ButtonText
                                                colorScheme="primary"
                                                onClick={() => {
                                                    setNewAnnouncement(true);
                                                }}
                                            > New
                                            </ButtonText>
                                        </ButtonGroup>
                                    }

                                    {announcementFetched && announcementFetched &&
                                        <Select id="selectState" label="State" defaultValue="Active" value={announcementState} onChange={changeAnnouncementState} >
                                        <option value="active">Active</option>
                                        <option value="to_be_released">Pending</option>
                                        <option value="past">Archived (Completed)</option>
                                        </Select>
                                    }
                                    
                                </Col>      
                            </Row>
                            <Row>                                
                                <Announcement PAGE_SIZE={10} 
                                fetch={handleAnnouncementsPageChange} fetched={announcementFetched} 
                                setSelectedAnnouncement={setSelectedAnnouncement} data={announcementsData} 
                                totalPages={announcementTotalPages} changeState={announcementState}/>
                            </Row>

                            <Row>
                            </Row>

                        </Grid>
                    </>
                )
            }
        </GlobalAlertContext.Consumer> 
    );

}


export default ManageAnnouncement;
